import { render, staticRenderFns } from "./AssignmentPrice.vue?vue&type=template&id=78f964ec"
import script from "./AssignmentPrice.vue?vue&type=script&lang=js"
export * from "./AssignmentPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports